export enum EVENT_STATUSES {
  ACTIVE = "active",
  CANCELED = "canceled",
}

